/** WARNING: This file is generated automatically **/

import type { TrackingContextValue } from '../providers/TrackingContext';
import { getEntities } from '../utils/getEntities';
import { getGTMData } from '../utils/getGTMData';
import { trackSelfDescribingEvent } from '../utils/trackSelfDescribingEvent';

/**
 * Fires when a link is clicked
 */
export interface LinkClick {
  /**
   * The text that is displayed to the user in English, if the text is in other language, do not pass a value
   */
  linkText?: string | null;
  /**
   * Resolver tag used to resolve this link (if applicable)
   */
  resolverTag?: string | null;
  /**
   * the URL the user is trasnferred to
   */
  destinationUrl: string;
}

export const linkClick = (data: Readonly<LinkClick>, context?: TrackingContextValue) => {
  window.__GTM_DATA_LAYER__?.push({ event: 'link_click', ...data, ...getGTMData(context) });

  trackSelfDescribingEvent(
    {
      event: {
        schema: 'iglu:com.starsgroup/link_click/jsonschema/2-0-1',
        data
      },
      context: getEntities(context)
    },
    context
  );
};
